<!-- fxLayoutGap.gt-sm kaldirildi, karsiligi SCSS'in SONUNDAKI @media (min-width: 960px)
     blogunda; bkz. oradaki ngx-layout/SSR notu. fxLayout="column" kaliyor: o SSR'da
     gercekten yaziliyor (sunucu HTML'inde flex-layout-0 sinifi + <style>), olculdu. -->
<div class="event-container" fxLayout="column" *ngIf="eventDetail">

    <!-- Görünürlük SCSS'te; bkz. event.component.scss başındaki ngx-layout/SSR notu. -->
    <btx-breadcrumb class="event-desktop-only" [items]="breadcrumbItems"></btx-breadcrumb>

    <!-- Mobil karşılığı .mobile-event-media içindeki .mobileapp-header-container (L164). -->
    <btx-title class="event-desktop-only" [title]="eventDetail?.eventName"></btx-title>


    <!--  EVENT DETAILS -->
    <div class="event-details" fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100%">

        <!--  Event Description      -->
        <btx-event-description class="event-desktop-only"
                               [venueName]="eventDetail?.venueName"
                               [venueCity]="eventDetail?.venueCity"
                               [startDate]="eventDetail?.firstPerformanceDate"
                               [endDate]="eventDetail?.lastPerformanceDate"
                               [hideVenue]="eventDetail?.hideVenue"
                               [hideSaleDate]="eventDetail?.hideSaleDate"
                               [venueUrl]="getVenuePageUrl()"
                               *ngIf="!eventDetail.flexibleTimeEventCheck"
                               [multiDate]="true" dateFormat="mediumDate"></btx-event-description>
      <!-- Flexible Event Description      -->
      <btx-event-description class="event-desktop-only"
                             *ngIf="eventDetail.flexibleTimeEventCheck"
                             [venueName]="eventDetail?.venueName"
                             [venueCity]="eventDetail?.venueCity"
                             [hideVenue]="eventDetail?.hideVenue"
                             [hideSaleDate]="eventDetail?.hideSaleDate"
                             [startDate]="eventDetail?.startShowDate"
                             [endDate]="eventDetail?.endShowDate"
                             [multiDate]="true"
                             [isFlexibleEvent]="true"
                             dateFormat="fullDate"
                             [venueUrl]="getVenuePageUrl()"></btx-event-description>

        <!-- EVENT SHARE LINK   -->
        <btx-share-button class="share-button"
                          *ngIf="config"
                          [menuTitle]="'performance.labels.shareTheEvents'|translate"
                          [title]="config.title"
                          [url]="config.url"
                          [description]="config.description"
                          [showText]="true"
                          [showIcon]="true"></btx-share-button>
    </div>

    <div class="event-media-container desktop-event-media">
      <ng-container *ngIf="isPhotoGalleryVisible() else singleImageTemplate">

          <ng-container *ngIf="photoItems.length>2 else threeImageTemplate">

              <figure class="event-img-container gallery-template">
                  <div class="event-image">
                      <!-- LCP adayı: lazy OLMAMALI, fetchpriority=high ile tarayıcı erken çeker -->
                      <img class=""
                           [src]="eventImageSrc"
                           fetchpriority="high"
                           width="1920"
                           height="1080"
                           alt="">
                  </div>
                  <div class="gallery-images">
                      <img class="gallery-image"
                           [src]="image"
                           loading="lazy"
                           data-fancybox="gallery"
                           *ngFor="let image of photoItems; let i=index"
                           [ngStyle]="{'display':i>3 ? 'none':null}"
                           alt="">
                  </div>

              </figure>
          </ng-container>

      </ng-container>

      <ng-template #threeImageTemplate>
          <figure class="event-img-container three-image-template">
              <div class="event-image">
                  <img class=""
                       [src]="eventImageSrc"
                       fetchpriority="high"
                       width="1920"
                       height="1080"
                       alt="">
              </div>
              <div class="event-image" *ngFor="let image of photoItems|slice:0:2">
                  <img class=""
                       [src]="image"
                       loading="lazy"
                       alt="">
              </div>

              <!-- <img class="new-image"
                      [src]="eventImageSrc"
                      [alt]="eventDetail.eventName">

              <section fxLayout="row wrap" fxLayoutGap="10px grid">
                  <figure *ngFor="let photo of photoItems|slice:0:4">
                      <a [href]="photo"
                          data-fancybox="gallery">
                          <img class="gallery-img"
                                  [src]="photo"
                                  alt="">
                      </a>
                  </figure>
              </section> -->
          </figure>
      </ng-template>

      <ng-template #singleImageTemplate>
          <ng-container *ngIf="eventDetail?.wideImage else eventImageTemplate">
              <figure class="event-img-container single-image-template">
                  <div class="event-image wide-image" [style.backgroundColor]="color">

                      <img class=""
                          [src]="wideImage"
                          fetchpriority="high"
                          width="2440"
                          height="688"
                          alt="">
                  </div>
              </figure>
          </ng-container>
      </ng-template>

      <ng-template #eventImageTemplate>
          <figure class="event-img-container single-image-template">
              <div class="event-image" [style.backgroundColor]="color">
                  <img class="bg"
                      [src]="eventImageSrc"
                      loading="lazy"
                      alt="">
                      <ng-container *ngIf="isAvifImage(eventImageSrc); else normalImage">
                        <picture>
                          <source
                            media="(max-width:649px)"
                            [srcset]="eventMidImageSrc"
                          />
                          <source
                            media="(min-width:650px)"
                            [srcset]="eventImageSrc"
                          />

                          <img
                            class="noGallery"
                            [src]="eventNoSrc"
                            [alt]="eventDetail?.eventName"
                            fetchpriority="high"
                            width="1920"
                            height="1080"
                            (error)="onImgError($event)"
                          />
                        </picture>
                      </ng-container>

                      <ng-template #normalImage>
                        <img
                          class="noGallery"
                          #eventImage
                          (load)="onLoadImage(eventImage)"
                          fetchpriority="high"
                          width="1920"
                          height="1080"
                          [src]="eventImageSrc"
                          [alt]="eventDetail?.eventName"
                        />
                      </ng-template>

              </div>
          </figure>
      </ng-template>
  </div>

  <div class="event-media-container mobile-event-media">
        <div class="mobileapp-header-container">{{eventDetail.eventName}}</div>
        <div class="favorite"  (click)="toggleFavorites()">
            <mat-icon  [ngClass]="IsFavorites(eventCode) ? 'favorite-filled' : 'favorite-btn'"  class="favorite-btn">favorite</mat-icon>
        </div>
      <btx-share-button *ngIf="config"
                        [menuTitle]="'performance.labels.shareTheEvents'|translate"
                        [title]="config.title"
                        [url]="config.url"
                        [description]="config.description"
                        [showText]="true"
                        [showIcon]="true"></btx-share-button>

        <ng-container *ngIf="eventDetail?.images?.length; else noGallery">
            <swiper *ngIf="eventDetail?.images && eventDetail.images.length > 0" class="mySwiper" [pagination]="true">

                <ng-template swiperSlide *ngFor="let image of mobileGallery">
                  <div class="mobileapp-header-container">{{eventDetail.eventName}}</div>
                  <div class="favorite"  (click)="toggleFavorites()">
                      <mat-icon  [ngClass]="IsFavorites(eventCode) ? 'favorite-filled' : 'favorite-btn'"  class="favorite-btn">favorite</mat-icon>
                  </div>
                    <img swiperSlide
                         [src]="image"
                         loading="lazy"
                         style="width: 100%"
                         alt="">
                </ng-template>
              </swiper>
        </ng-container>

        <ng-template #noGallery>
            <!-- <img class="bg noGallery"
            [src]="eventImageSrc"
            loading="lazy"
            alt=""> -->
            <ng-container *ngIf="isAvifImage(eventImageSrc); else normalImage">
                <picture>
                  <source
                    media="(max-width:649px)"
                    [srcset]="eventMidImageSrc"
                  />
                  <source
                    media="(min-width:650px)"
                    [srcset]="eventImageSrc"
                  />

                  <img
                    class="bg noGallery"
                    [src]="eventNoSrc"
                    [alt]="eventDetail?.eventName"
                    loading="lazy"
                    (error)="onImgError($event)"
                    #eventImage
                    (load)="onLoadImage(eventImage)"
                  />
                </picture>
              </ng-container>

              <ng-template #normalImage>
                <img
                  class="bg noGallery"
                  #eventImage
                  (load)="onLoadImage(eventImage)"
                  loading="lazy"
                  [src]="eventImageSrc"
                  [alt]="eventDetail?.eventName"
                />
              </ng-template>
        </ng-template>


  </div>

  <!--  Event Description      -->
  <btx-event-description class="event-mobile-only"
                         [venueName]="eventDetail?.venueName"
                         [venueCity]="eventDetail?.venueCity"
                         [startDate]="eventDetail?.firstPerformanceDate"
                         [endDate]="eventDetail?.lastPerformanceDate"
                         [hideVenue]="eventDetail?.hideVenue"
                         [hideSaleDate]="eventDetail?.hideSaleDate"
                         [venueUrl]="getVenuePageUrl()"
                         [multiDate]="true" dateFormat="mediumDate"
                         *ngIf="!eventDetail.flexibleTimeEventCheck"></btx-event-description>
  <!-- Flexible Event Description      -->
  <btx-event-description class="event-mobile-only"
                         *ngIf="eventDetail.flexibleTimeEventCheck"
                         [venueName]="eventDetail?.venueName"
                         [venueCity]="eventDetail?.venueCity"
                         [hideVenue]="eventDetail?.hideVenue"
                         [hideSaleDate]="eventDetail?.hideSaleDate"
                         [startDate]="eventDetail?.startShowDate"
                         [endDate]="eventDetail?.endShowDate"
                         [multiDate]="true"
                         [isFlexibleEvent]="true"
                         dateFormat="fullDate"
                         [venueUrl]="getVenuePageUrl()"></btx-event-description>


    <section class="event-info-container">
        <btx-event-page-tab-menu></btx-event-page-tab-menu>

        <div fxLayout="column" fxLayout.gt-md="row" fxLayoutGap="15px" fxLayoutAlign="start start">

            <!-- Etkinlik Bilgileri -->
            <div class="event-info-wrapper" fxLayout="column" fxLayoutGap="10px" fxFlex="67%" fxFlex.lt-md="100%">
                <!-- <h2 class="title heading-medium" translate="performance.labels.about"></h2> -->
              <h2 class="title heading-medium" translate="performance.labels.about"></h2>

                <btx-read-more [text]="eventDetail?.eventDescription" [maxLength]="300">
                </btx-read-more>
                <!--Event Sponsor Image-->
                <div class="sponsor-container" *ngIf="eventDetail.sponsorImage  && eventDetail.sponsorImage!=''">
                    <img class="sponsor-image"
                    loading="lazy"
                         [src]="eventDetail.sponsorImage|secureImage:environment.sponsorImageBasePath" alt="sponsor-image">
                </div>

                <mat-divider></mat-divider>


                <!-- Performans Listesi -->
              <div fxLayout="column" id="eventsList" *ngIf="!isEventEnded">
                <h3 class="calendar-header" translate="performance.labels.eventsList"></h3>
                <btx-performance-list [eventCode]="eventCode"
                                      [eventName]="eventDetail.eventName"
                                      [region]="region.regionName"
                                      [lang]="i18n.currentLang"
                                      [definitionCode]="cDefinitionQueryParam"></btx-performance-list>
              </div>

              <!-- Etkinlik sona erdi: satın alma akışı yerine alternatif yollar.
                   Sunucu bu durumda aynı URL'de 410 döner. -->
              <div class="event-ended-container" *ngIf="isEventEnded">
                <h3 class="calendar-header" translate="event.labels.eventEndedTitle"></h3>
                <p class="event-ended-description" translate="event.labels.eventEndedDescription"></p>
                <ul class="event-ended-links">
                  <li *ngFor="let artist of endedEventArtists">
                    <a [routerLink]="['/artist', artist.artistId, currentRegion.name, currentLang, artist.keyUrlText]">
                      {{ 'event.labels.eventEndedArtistEvents' | translate:{ artistName: artist.artistName } }}
                    </a>
                  </li>
                  <li *ngIf="eventDetail?.eventCategoryCode">
                    <a [href]="getCategoryPageUrl()">
                      {{ 'event.labels.eventEndedCategoryEvents' | translate:{ categoryName: eventDetail?.eventCategory } }}
                    </a>
                  </li>
                </ul>
              </div>
              <div class="warning-box" *ngIf="isFlexibleEventTime">
                <span class="warning-icon">&#9888;</span>
                <span>
                  {{ 'shared.labels.flexibleTimeWarningMessage' | translate:{ dayMonthSection: dayMonthSection, hourSection: hourSection } }}
                </span>
              </div>
                <section class="event-rules-container"
                id="rules">
                    <h2 class="heading-medium"
                    translate="shared.labels.eventRules"></h2>
                    <div [innerHTML]="eventDetail.eventRules" class="mb-2"></div>
                    <div [innerHTML]="eventDetail.info"></div>
                </section>
            </div>


            <div fxFlex class="side-image-container">
              <div class="artist-container" *ngIf="hasArtists">
                <h2 class="title heading-medium">{{'shared.labels.artists'|translate}}</h2>
                <div class="artists-list">
                    <ng-container *ngFor="let artist of artistDetails">
                  <div class="artist-image"  *ngIf="artist.showEventPage">
                    <a [routerLink]="['/artist', artist.artistId,currentRegion.name,currentLang,artist.keyUrlText]">
                      <img [src]="getArtistProfilePhoto(artist.artistProfilePhoto)" [alt]="artist.artistName">
                      <span>{{artist.artistName}}</span>
                    </a>
                  </div>
                </ng-container>
                </div>
              </div>
              <div class="side-image-wrapper">
                <div id='div-gpt-ad-1664353181968-0' style='min-width: 300px; min-height: 600px;'></div>
              </div>
            </div>
        </div>
    </section>

</div>
